import * as conversationTypes from './conversationsTypes';

const conversationsTypesTitlesMap = {
  [conversationTypes.VIDEO]: {
    id: 'Conversations.ConversationType.Video',
    defaultMessage: '** Video',
  },
  [conversationTypes.AUDIO_EXTERNAL]: {
    id: 'Conversations.ConversationType.AudioExternal',
    defaultMessage: '** Audio external',
  },
};

export const getConversationTypeTitle = (type) => conversationsTypesTitlesMap[type];
